import styled from 'styled-components';

export const Container = styled.div`
  height: 80vh;
  max-height: 80vh;
`;
